import { Component, OnInit } from '@angular/core';
import { style, animate, transition, trigger } from '@angular/animations';
import { DataToSaveService } from '../../../service/data-to-save.service';
import { NotificationsService } from '../../../service/notifications.service';


@Component({
  selector: '[app-notify]',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.css'],
  animations: [trigger('fadeInOut', [transition('void => *', [style({opacity: 0}), animate(500,
    style({opacity: 1}))]), transition('* => void', [animate(500, style({opacity: 0}))])])]
})

export class NotifyComponent implements OnInit {

  fileName: string;
  notification: string;

  constructor(private dataToSaveService: DataToSaveService, private notificationsService: NotificationsService) {}

  ngOnInit () {
    this.dataToSaveService.getFileNameEmitter().subscribe((filename) => {
      this.fileName = filename;
      setTimeout(() => {
        this.fileName = '';
      }, 5000);
    });
    this.notificationsService.getNotifications().subscribe((notification) => {
      this.notification = notification;
      setTimeout(() => {
        this.notification = '';
      }, 5000);
    });
  }

  close() {
   this.fileName = '';
   this.notification = '';
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/saved-files/notify/notify.component.ts